export { default as compose } from './compose';
export { createClassResolver } from './createClassResolver';
export { mergeProps } from './mergeProps';
export { mergeSlotProp } from './mergeSlotProp';
export * from './types';

import './version';
